<template lang="pug">
  form(@submit.prevent="next")
    modal-anexos(ref="modalAnexos" :anexos="comentario.anexos" @remove="onRemoveAnexo" @unremove="onUnremoveAnexo")
    p.text-large - Comentário do Documento
    .columns
      .column.col-8.col-md-6.col-sm-12
        .columns
          .columns.column.col-12.align-end
            .column.col-6
              form-group(:label="'comentario.realizado_em' | tModel" :validation="$v.resource.comentarios.$each[0].realizado_em")
                datepicker(
                  v-if="$v.resource.comentarios.$each[0].realizado_em.$model !== 'now'"
                  v-model="$v.resource.comentarios.$each[0].realizado_em.$model"
                  type="datetime"
                  format="DD/MM/YYYY HH:mm"
                )
                .columns(v-else)
                  .column
                    output.form-input Agora
                  .column.col-auto
                    a.btn.btn-link.mt-1(
                      @click="$v.resource.comentarios.$each[0].realizado_em.$model = ''"
                    )
                      i.fa.fa-calendar
                      |  Outra data
            .column.col-auto
              a.btn.btn-link.mb-2(
                v-if="$v.resource.comentarios.$each[0].realizado_em.$model !== 'now'"
                @click="$v.resource.comentarios.$each[0].realizado_em.$model = 'now'"
              )
                i.fa.fa-calendar
                |  Agora
          .column.col-12
            form-group(:label="'comentario.comentario_situacao' | tModel" :validation="$v.resource.comentarios.$each[0].comentario_situacao_id")
              comentario-situacao-picker(v-model="$v.resource.comentarios.$each[0].comentario_situacao_id.$model" rows="5")
          .column.col-12
            form-group(:label="'comentario.descricao' | tModel" :validation="$v.resource.comentarios.$each[0].descricao")
              textarea.form-input(v-model.trim="$v.resource.comentarios.$each[0].descricao.$model" rows="5")
            .text-error(v-if="$v.countFotos.$invalid")
              | - Você precisa adicionar pelo menos #[b {{ minimoFotos }}] {{ minimoFotos === 1 ? 'foto' : 'fotos' }} no comentário
          .column.col-12(v-if="comentario.anexos.length > 0")
            a.c-hand(@click="$refs.modalAnexos.open()")
              | {{ countFotos }} {{ countFotos === 1 ? 'imagem adicionada ao comentário' : 'imagens adicionadas ao comentário' }}
            .divider
          .column.col-12
            anexos(v-model="$v.resource.comentarios.$each[0].anexos.$model")
    .pt-2
      .divider
      button.btn.btn-primary(:disabled="$v.$invalid || uploading")
        btn-content(name="next")
</template>

<script>
import Comentario from '@/models/Comentario'
import Anexos from './components/Anexos'
import mixin from './mixin'
import { required, minValue, minLength } from 'vuelidate/lib/validators'
import ModalAnexos from './components/ModalAnexos.vue'

export default {
  vuex: {
    uploads: {
      state: ['uploading'],
    },
  },
  mixins: [mixin],
  validations() {
    if (this.revisao) {
      return {
        countFotos: {},
        resource: {
          comentarios: {
            $each: {
              descricao: {},
              realizado_em: {},
              anexos: { $each: {} },
              comentario_situacao_id: {},
            },
          },
        },
      }
    }
    return {
      countFotos: {
        minValue: minValue(this.minimoFotos),
      },
      resource: {
        comentarios: {
          length: { minValue: minValue(1) },
          $each: {
            descricao: { required, minLength: minLength(10) },
            realizado_em: {},
            anexos: { $each: {} },
            comentario_situacao_id: {},
          },
        },
      },
    }
  },
  components: { Anexos, ModalAnexos },
  computed: {
    minimoFotos() {
      return this.resource.modelo.params.osm.minimo_fotos
    },
    comentario() {
      return this.resource.comentarios[0]
    },
    countFotos() {
      return this.comentario.anexos.filter(({ _destroy }) => !_destroy).length
    },
  },
  methods: {
    onRemoveAnexo(index) {
      if (this.resource.comentarios[0].anexos[index].id) {
        this.resource.comentarios[0].anexos[index]._destroy = true
      } else {
        this.$delete(this.resource.comentarios[0].anexos, index)
      }
    },
    onUnremoveAnexo(index) {
      this.resource.comentarios[0].anexos[index]._destroy = false
    },
  },
  created() {
    if (this.resource.comentarios.length === 0) {
      this.resource.comentarios.push(new Comentario())
    }
  },
}
</script>
